@if (vm$ | async; as vm) {
  @for (faq of vm.model.faqs; track faq) {
    <div>
      <a class="faqs__question" (click)="faq.display = !faq.display" href="javascript:void(0)">
        {{ faq.question }}
      </a>
      @if (faq.display) {
        <p class="" [innerHTML]="faq.answer"></p>
      }
      @if (faq.display) {
        @for (childFaq of faq.faqs; track childFaq) {
          <div class="faqs__children">
            <a class="faqs__question" (click)="childFaq.display = !childFaq.display" href="javascript:void(0)">
              {{ childFaq.question }}
            </a>
            @if (childFaq.display) {
              <p [innerHTML]="childFaq.answer"></p>
            }
          </div>
        }
      }
    </div>
  }
}